var _polygon, _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "stroke-color-main",
    points: "17.487 67.959 99.096 39.601 182.52 69.938 100.91 99.285 17.487 67.959"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke-color-main",
    d: "M49.481,143.887s12.74,16.849,49.615,16.849,53.1-16.849,53.1-16.849V102.03L100.91,120.475,49.481,101.163Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "stroke-color-main",
    x1: 23.532,
    y1: 71.916,
    x2: 23.532,
    y2: 132.589
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.9db171a345015c6bf76047a11bee20c2.svg";
export { ForwardRef as ReactComponent };